<template>
  <section :class="[$options.name]">
    <AccountMenu :is-mobile="isMobile" :redirection="{ path: '/login', text: translations }" class="tw:mb-10" />

    <AccountContent :is-mobile="isMobile">
      <template v-if="passwordAction === 'forgot_password'">
        <AccountForgotPasswordForm :is-mobile="isMobile" />
      </template>
      <template v-if="passwordAction === 'expired_time'">
        <AccountForgotPasswordForm :is-mobile="isMobile" :password-action="passwordAction" />
      </template>
      <template v-if="passwordAction === 'reset_password_token' || passwordAction === 'new_account_password'">
        <AccountResetPasswordForm :is-mobile="isMobile" :password-action="passwordAction" />
      </template>
    </AccountContent>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import AccountForgotPasswordForm from "../components/Account/AccountForgotPasswordForm.vue";
import AccountResetPasswordForm from "../components/Account/AccountResetPasswordForm.vue";
import AccountMenu from "../components/Account/AccountMenu.vue";
import AccountContent from "../components/Account/AccountContent.vue";

export default defineComponent({
  name: "PagePasswordManagement",
  components: {
    AccountMenu,
    AccountContent,
    AccountForgotPasswordForm,
    AccountResetPasswordForm,
  },
  setup() {
    const translations = window._trans._account.login.buttons.login;
    // @ts-ignore this is set in the template
    const passwordAction = window._password_action;
    // @ts-ignore this is set in the template
    const passwordToken = window._password_token;

    const isMobile = ref<boolean>(false);

    function checkIsMobile() {
      isMobile.value = document.documentElement.clientWidth < 992;
    }

    onMounted(() => {
      window.addEventListener("resize", checkIsMobile);
      checkIsMobile();
    });

    function gotoRegister() {
      window.location.href = "/register";
    }

    return {
      gotoRegister,
      isMobile,
      translations,
      passwordAction,
      passwordToken,
    };
  },
});
</script>

<style lang="scss">
@use "vue-app/assets/scss/views/account/account";
</style>
